// extracted by css-extract-rspack-plugin
export default {"UpsellBannerOcticon":"UpsellBanner-module__UpsellBannerOcticon__KdEeJ","UpsellBannerHeading":"UpsellBanner-module__UpsellBannerHeading__QnT6P"};